import { getEntityRepository as getState } from "modules/root/root-selectors";
import { createSelector } from "reselect";

export const getDiagnostics = createSelector(
  getState,
  state => state.diagnostics
);
export const getQuestions = createSelector(getState, state => state.questions);
export const getDiagnosticSessions = createSelector(
  getState,
  state => state.diagnosticSessions
);
export const getPainZones = createSelector(getState, state => state.painZones);
export const getHelpTexts = createSelector(getState, state => state.helpTexts);



// WEBPACK FOOTER //
// ./src/modules/entity-repository/entity-repository-selectors.js